document.addEventListener("DOMContentLoaded", function () {
  const wishlistButtons = document.querySelectorAll(".add-to-wishlist");
  const wishlistButtonsPdp = document.querySelectorAll(".add-to-wishlist-pdp");
  const wishlistCountEl = document.getElementById("wishlist-count");

  const customerId = window.customerId;

  let wishlist = [];

  // Graceful fallback if customer not logged in
  // if (!customerId) {
  //   console.warn("Customer not logged in or missing tokens.");
  //   return;
  // }

  fetch(window.wishlistGetUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })
  .then(response => response.json())
  .then(data => {
    const productArray = data?.data?.product || [];

    // Extract only the `id` from each product object
    wishlist = productArray.map(product => product.id);
    configureWishlistButtons();
    console.log('Wishlist fetched successfully:', data.data.product);
  })
  .catch(error => {
    console.error('Error fetching wishlist:', error);
  });

  function configureWishlistButtons() {
    wishlistButtons.forEach(button => {
      const id = button.dataset.productId;
      if (wishlist.includes(id)) {
        button.classList.add("wishlist-active");
      } else {
        button.classList.remove("wishlist-active");
      }
    });
    wishlistButtonsPdp.forEach(button => {
      const id = button.dataset.productId;
      if (wishlist.includes(id)) {
        button.classList.add("wishlist-active");
      } else {
        button.classList.remove("wishlist-active");
      }
    });
  };

  wishlistButtons.forEach(button => {
    button.addEventListener("click", async function () {
      const productHandle = this.dataset.productHandle;
      const productId = this.dataset.productId;
      if (!customerId) {
        console.warn("Customer not logged in.");
        window.location.href = "/account/login";
        // return;
      } else {
        await updateWishlist(wishlist, productId, productHandle, button);
      }
    });
  });

   wishlistButtonsPdp.forEach(button => {
    button.addEventListener("click", async function () {
      const productHandle = this.dataset.productHandle;
      const productId = this.dataset.productId;
      if (!customerId) {
        console.warn("Customer not logged in.");
        window.location.href = "/account/login";
        // return;
      } else {
        await updateWishlist(wishlist, productId, productHandle, button);
      }
    });
  });

  function updateWishlistCount() {
    if (!wishlistCountEl) return;
    if (wishlist.length > 0) {
      wishlistCountEl.textContent = wishlist.length;
      wishlistCountEl.style.display = "flex";
    } else {
      wishlistCountEl.textContent = "";
      wishlistCountEl.style.display = "none";
    }
  }

  // function showSuccessNotification(message) {
  //   const existing = document.getElementById("success-notification");
  //   if (existing) existing.remove();

  //   const notification = document.createElement("div");
  //   notification.id = "success-notification";
  //   notification.className = "success-notification";
  //   notification.innerHTML = `
  //     <div class="success-msg">
  //       <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9">
  //         <path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/>
  //       </svg>
  //       <span>${message}</span>
  //     </div>
  //   `;
  //   document.body.appendChild(notification);

  //   setTimeout(() => {
  //     notification.style.opacity = '0';
  //     setTimeout(() => notification.remove(), 1000);
  //   }, 2000);
  // }

  function showSuccessNotification(message) {
  // Create container
  const container = document.createElement("div");
  container.id = "notification-container";
  container.style.position = "fixed";
  container.style.top = "20px";
  container.style.right = "20px";
  container.style.zIndex = "9999";

  // Create notification element
  const notification = document.createElement("div");
  notification.className = "success-notification";
  notification.style.background = "#fff";
  notification.style.color = "#000";
  notification.style.border = "1px solid #000";
  notification.style.padding = "10px 15px";
  notification.style.borderRadius = "6px";
  notification.style.display = "flex";
  notification.style.alignItems = "center";
  notification.style.fontSize = "14px";
  notification.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.1)";
  notification.style.transition = "opacity 0.3s ease";

  notification.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9" style="width: 16px; height: 16px; margin-right: 8px;">
      <path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/>
    </svg>
    <span>${message}</span>
  `;

  container.appendChild(notification);
  document.body.appendChild(container);

  // Fade out and remove
  setTimeout(() => {
    notification.style.opacity = "0";
    setTimeout(() => {
      container.remove();
    }, 3000);
  }, 4000);
}

  async function createWishlist(wishlist, productId, productHandle, button) {
    // const uniqueProducts = Array.from(new Set([...wishlist, productId]));
    // data = {
    //   product: uniqueProducts,
    // };

    const response = await fetch(`${window.wishlistUpdateUrl}?productId=${productId}&productHandle=${productHandle}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      // body: JSON.stringify(data),
    });

    const result = await response.json();

    if (result.status === "error") {
      console.error("Error updating metafield:", result);
    } else {
      console.log("Wishlist updated successfully.", result);
      const isAdding = !wishlist.includes(productId);

      if (isAdding) {
        wishlist.push(productId);
        showSuccessNotification("Added to Wishlist.");
        button.classList.add("wishlist-active");
      } else {
        const index = wishlist.indexOf(productId);
        if (index > -1) wishlist.splice(index, 1);
        showSuccessNotification("Removed from Wishlist.");
        button.classList.remove("wishlist-active");
      }
    }
  }

   async function updateWishlist(wishlist, productId, productHandle, button) {
    const isAdding = !wishlist.includes(productId);
    if (isAdding) {
      const response = await fetch(`${window.wishlistUpdateUrl}?productId=${productId}&productHandle=${productHandle}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      const result = await response.json();
  
      if (result.status === "error") {
        console.error("Error updating metafield:", result);
      } else {
        console.log("Wishlist updated successfully.", result);
        wishlist.push(productId);
        showSuccessNotification("Added to Wishlist.");
        button.classList.add("wishlist-active");
      }
    } else {
      const response = await fetch(`${window.wishlistDeleteUrl}?productId=${productId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      const result = await response.json();
  
      if (result.status === "error") {
        console.error("Error updating metafield:", result);
      } else {
        console.log("Wishlist updated successfully.", result);
        const index = wishlist.indexOf(productId);
        if (index > -1) wishlist.splice(index, 1);
        showSuccessNotification("Removed from Wishlist.");
        button.classList.remove("wishlist-active");
      }
    }
  }

  updateWishlistCount();
});
